export enum LoginActionType {
    POST_LOGIN_SUCCESS = 'POST_LOGIN_SUCCESS',
    POST_LOGIN_UNSUCCESS = 'POST_LOGIN_UNSUCCESS',
    POST_LOGIN_RESET = 'POST_LOGIN_RESET'
}

